import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VApp, [_c(VForm, {
    ref: "form",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c(VContainer, {
    class: _vm.loginContainerStyle(),
    attrs: {
      "fluid": ""
    }
  }, [!_vm.isDefaultSvgLogo() ? _c('core-logo-custom', {
    attrs: {
      "image": _vm.loginLogo.image,
      "orientation": _vm.loginLogo.orientation
    }
  }) : _vm._e(), _c('div', {
    staticClass: "dsuite-panel",
    style: _vm.getBG()
  }, [_vm.isDefaultSvgLogo() ? _c(VRow, {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCol, {
    staticClass: "pa-0",
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c(VSheet, {
    staticClass: "mx-auto dsuite-dgmnd-logo dsuite-login-bg"
  }, [_c('core-logo-niotix', {
    attrs: {
      "width": "100",
      "color": "#00A9E1",
      "dark": _vm.UiTheme
    }
  })], 1)], 1)], 1) : _vm._e(), _c(VRow, {
    staticClass: "fill-height",
    staticStyle: {
      "margin-top": "-40px !important"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCol, {
    staticClass: "text-center px-12",
    attrs: {
      "cols": "12",
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "mx-auto",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "pb-10",
    attrs: {
      "cols": "12",
      "align": "left"
    }
  }, [_c('h1', {
    staticClass: "mobile-headline",
    staticStyle: {
      "color": "#fff",
      "margin-bottom": "-60px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('Common.resetPassword')) + "\n                  ")])]), _c(VCol, {
    staticClass: "pt-10 pb-0",
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "8",
      "justify": "top"
    }
  }, [_c(VTextField, {
    attrs: {
      "rules": _vm.emailRules,
      "label": _vm.$i18n_t('Common.enterEmail'),
      "disabled": _vm.showMessage,
      "name": "Email",
      "required": "",
      "background-color": _vm.themeGetBgColors(),
      "filled": "",
      "clearable": "",
      "autofocus": ""
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1), _c(VCol, {
    staticClass: "pb-0",
    staticStyle: {
      "padding-top": "11px"
    },
    attrs: {
      "cols": "4"
    }
  }, [_c(VBtn, {
    staticClass: "elevation-0",
    staticStyle: {
      "border-radius": "4px",
      "height": "55px"
    },
    attrs: {
      "disabled": !_vm.valid || _vm.showMessage || _vm.loading,
      "color": _vm.themeGetBgColors()
    },
    on: {
      "click": function ($event) {
        return _vm.forgotPass();
      }
    }
  }, [_c(VIcon, {
    staticClass: "mr-2"
  }, [_vm._v("fal fa-paper-plane")]), _vm._v("\n                    " + _vm._s(_vm.$i18n_t('Common.resetPassword')) + "\n                  ")], 1)], 1), _c(VCol, {
    staticClass: "pb-10",
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "8",
      "align": "left"
    }
  }, [_c(VCard, {
    staticClass: "elevation-0"
  }, [_c(VCardText, {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('Common.resetPwdInfoText2')) + "\n                    ")])], 1)], 1)], 1)], 1)])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };